<template>
  <div class="d-flex flex-column justify-start align-center">
    <div class="text-h6 mt-3">
      <del style="font-size: 0.9rem" v-if="prix_barre > 0">{{ prix_barre }}€</del> {{ get_current_tarif() }}
    </div>
    <v-dialog v-if="has_upcoming_majoration" v-model="showDialog" width="500" max-width="100%" scroll-strategy="none">
      <template v-slot:activator="{ props }">
        <v-btn color="darkblue" variant="plain" size="small" v-bind="props"><v-icon icon="mdi-information-outline"
            class="mr-1" size="large"></v-icon> Détails tarif </v-btn>
      </template>

      <v-card>
        <v-card-text>
          <div class="d-flex bg-grey_1 bordered flex-column justify-start px-2 py-1 rounded tarif_pack_item">
            <div class="font-weight-bold"><v-icon icon="mdi-bookmark-outline" color="primary"
                size="small"></v-icon>Tarif: {{
              get_current_tarif() }}€</div>
            <div>
              <div>
                <div class="text-body-2 text-darkgrey" v-for="(majoration, index_majoration) in get_majorations()"
                  :key="index_majoration">
                  <div v-html="majoration"></div>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" block @click="showDialog = false">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
export default {
  props: ["base", "metadatas"],
  data() {
    return {
      showDialog: false,
    };
  },
  computed: {
    prix_barre() {
      for (let i = 0; i < this.metadatas.length; i++) {
        if (this.metadatas[i].nom == "prix_barre") {
          return parseInt(this.metadatas[i].valeur);
        }
      }
      return 0;
    },
    has_upcoming_majoration() {
      for (let i = 0; i < this.metadatas.length; i++) {
        if (this.metadatas[i].nom.match(/majoration[_][1-9][_]date/g)) {
          let now = this.$moment();
          let date_majoration = this.$moment(this.metadatas[i].valeur);
          if (now.isBefore(date_majoration)) {
            return true;
          }
        }
      }
      return false;
    },
  },
  methods: {
    get_majorations() {
      let response = [];
      for (let i = 0; i < this.metadatas.length; i++) {
        if (this.metadatas[i].nom.match(/majoration[_][1-9][_]date/g)) {
          let now = this.$moment();
          let date_majoration = this.$moment(this.metadatas[i].valeur);
          if (now.isBefore(date_majoration)) {
            let nom_tarif_majore = this.metadatas[i].nom.replace("date", "tarif");
            let tarif_majore = this.get_majoration_price(nom_tarif_majore);
            response.push("Majoration le " + this.$moment(this.metadatas[i].valeur).format("DD/MM/YYYY") + " à <b>" + tarif_majore + "€</b>");
          }
        }
      }
      return response;
    },
    get_majoration_price(nom) {
      for (let i = 0; i < this.metadatas.length; i++) {
        if (this.metadatas[i].nom == nom) {
          return this.metadatas[i].valeur;
        }
      }
      return "NC";
    },
    get_current_tarif() {
      let prix = this.base;
      for (let i = 0; i < this.metadatas.length; i++) {
        if (this.metadatas[i].nom.match(/majoration[_][1-9][_]date/g)) {
          let now = this.$moment();
          let date_majoration = this.$moment(this.metadatas[i].valeur);
          if (now.isAfter(date_majoration)) {
            let nom_tarif_majore = this.metadatas[i].nom.replace("date", "tarif");
            let tarif_majore = this.get_majoration_price(nom_tarif_majore);
            if (parseInt(tarif_majore) > parseInt(prix)) {
              prix = tarif_majore;
            }
          }
        }
      }
      if (parseInt(prix) > 0) {
        return prix + "€";
      }
      return "Gratuit";
    },
  },
  created() { },
};
</script>

<style lang="scss" scoped></style>